const MyComputed  = {
  // install( Vue, options) {
  install( Vue) {
    Vue.mixin({
      // mounted() {
      //   console.log("My Role Plugin mounted")
      // },
      computed: {
        currentUser() {
          // console.log("currentUser");
          // console.log(this.$store.state.auth.user);
            const user = this.$store?.state?.auth?.user;
            return user && Object.keys(user).length ? user : null;
        },
        activeCompetitions() {
          // console.log("activeCompetitions");
          // console.log(this.$store.state.competition.activeCompetitions);
          return this.$store.state.competition.activeCompetitions;
        },
        participantCompetitions() {
          // console.log("participantCompetitions");
          // console.log(this.$store.state.auth.participant.participantCompetitions);
          return this.$store.state.participant?.participantCompetitions ?? this.$store.state.auth?.participantCompetitions ?? [];
        },
        selectedCompetition: {
          cache: false,
          get() {
            // console.log("selectedCompetition");
            const selectedCompetitionId = this.$store.state.competition.selectedCompetitionId;
            return this.$store.state.competition.activeCompetitions.find(comp => comp.id == selectedCompetitionId);
          }
        },
        selectedCompetitionId() {
          // console.log("selectedCompetitionId");
          // console.log(this.$store.state.competition.selectedCompetitionId);
          return this.$store.state.competition.selectedCompetitionId;
        },
        selectedParticipantId() {
          // console.log("selectedParticipant");
          // console.log(this.$store.state.participant.selectedParticipant);
          return this.$store.state.participant.selectedParticipantId;
        },
        currentUserIsParticipant() {
          // try {
          const debug = false;
            if (debug) console.log("currentUserIsParticipant");
            if (debug) console.log(this.$route);
            if (debug) console.log(this.$route.params);
            if (debug) console.log(this.$store.state.auth);
    
            if ( ! this.participantCompetitions ) {
              console.log("No participantcompetitions");
              return false;
            }
            if (debug) console.log("this.participantCompetitions");
            if (debug) console.log(this.participantCompetitions);
            // let competition_id = this.$route.params.competition_id;
            if ( ! this.selectedCompetition ) {
              console.log("No selected competition");
              return false;
            }
            if (debug) console.log(`selected competition_id: ${this.selectedCompetitionId}`);
            // let participant_id = this.$route.params.participant_id;
            let found = this.participantCompetitions.find( obj => {
              return obj.competition_id == this.selectedCompetitionId; 
            })
            if (debug) console.log("Array find done");
            if (debug) console.log(found);
            if (found ) {
              if (debug) console.log(`Found`);
              return true;
            }
          // } catch (error) {
          //   console.log(`Error: ${error}`);
          //   return false;
          // }
          if (this.debug) console.log(`False`);
          return false;
        },
        currentUserIsNum() {
          return /^\d+$/.test(this.$store.state.auth.user);
        },
      },
      methods: {
      }
    })
  }
}

export default MyComputed;
